import { Component, AfterViewInit, ChangeDetectorRef, ViewChild, Injector } from '@angular/core';
import { Transaction, TrackingStatus, PoolOrder, TransactionGt } from 'src/app/models/transaction';
import { TransactionService } from 'src/app/services/transaction.service';
import { DatePipe } from '@angular/common';
import { Alert } from 'src/app/models/base-response';
import { Router, ActivatedRoute } from '@angular/router';
import { PoType } from 'src/app/models/transaction';
import * as $ from 'jquery';
import { LazyLoaderService } from 'src/app/services/lazy-loader.service';
import { AlertComponent } from 'src/app/alert/alert.component';
import * as firebase from 'firebase';
import * as _ from 'lodash';

declare var $: any;

export enum Menu {
  ListTransaction,
  DetailTransaction,
  DetailPoolOrder,
  DetailTransactionGt
}

@Component({
  selector: 'app-list-transaction',
  templateUrl: './list-transaction.component.html',
  styleUrls: ['./list-transaction.component.css'],
})
export class ListTransactionComponent implements AfterViewInit {
  start: string = '';
  end: string = '';

  transCreateds: Transaction[] = [];
  transProcesseds: Transaction[] = [];
  transSents: Transaction[] = [];
  transReceiveds: Transaction[] = [];
  transPoolOrder: PoolOrder[] = [];
  transReceivedsGt: TransactionGt[] = []

  isLoadingCreated: boolean = false;
  isLoadingProcessed: boolean = false;
  isLoadingSent: boolean = false;
  isLoadingReceived: boolean = false;
  isLoadingPoolOrder: boolean = false;
  isLoadingReceivedGt: boolean = false;

  public filterCreated = 0;
  public filterReceived = 0;
  public filterPoolOder = 0;
  public filterReceivedGt = 0;

  isErrorCreated: boolean = false;
  isErrorProcessed: boolean = false;
  isErrorSent: boolean = false;
  isErrorReceived: boolean = false;
  isErrorPoolOrder: boolean = false;
  isErrorReceivedGt: boolean = false;

  alertCreated: Alert;
  alertProcessed: Alert;
  alertSent: Alert;
  alertReceived: Alert;
  alertPoolOrder: Alert;
  alertReceivedGt: Alert;

  menu: Menu;
  transaction: Transaction;
  transactionGt: TransactionGt | null;
  poolOrderId: string;

  activeTab = null;

  canShowMore = false;
  limit = 10;
  offset = 0;
  tab = '';
  receivedGtMetaData = {
    page: 1,
    limit: 10,
    totalRows: 0,
    isShowMore: false
  };
  popupMessageCancelTransaction: any | null
  popupMessageReminderTransaction: any | null

  @ViewChild('alertComponent') alertComponent: AlertComponent;

  get getTrackingStatus() {
    return TrackingStatus;
  }

  constructor(
    private lazyLoaderService: LazyLoaderService,
    private datepipe: DatePipe,
    private router: Router,
    private route: ActivatedRoute,
    private transService: TransactionService,
    private changeDetection: ChangeDetectorRef
  ) {
    this.popupMessageCancelTransaction = route.snapshot.data.popup_message_cancel_transaction;
    this.popupMessageReminderTransaction = route.snapshot.data.popup_message_reminder_transaction;
  }

  ngAfterViewInit() {
    firebase.analytics().logEvent('transaksi_page');

    this.route.queryParams.subscribe(params => {
      if (params['tab']) {
        this.tab = params['tab'];

        if (this.tab === 'created') {
          $("ul.tabs li").removeClass("current");
          $(".tab-content").removeClass("current");

          this.activeTab = "created"
          $("#tab-2").addClass("current");
        }

        // if (this.tab === 'pool-order') {
        //   this.checkGT();
        // }

        if (this.tab === 'received-gt') {
          $("ul.tabs li").removeClass("current");
          $(".tab-content").removeClass("current");

          this.activeTab = "received-gt"
          $("#tab-1").addClass("current");
        }
      } else {
        if (!this.isUserGT()) {
          this.activeTab = 'pool-order';
          // this.checkGT();
        } else {
          this.activeTab = 'received-gt';
        }
      }
    });

    const transactionId = localStorage.getItem('transactionId');
    const typeTransaction = localStorage.getItem('typeTransaction');
    if (transactionId && typeTransaction) {
      if (typeTransaction === '7') {
        this.transService.getTransactionDetail(
          transactionId,
          (resp) => {
            localStorage.setItem('transactionId', '');
            localStorage.setItem('typeTransaction', '');
            this.navigateDetail(resp.data[0]);
          },
          (err) => {
          }
        );
      } else if (typeTransaction === '8') {
        this.navigateDetailPoolOrder(transactionId);
        localStorage.setItem('transactionId', '');
        localStorage.setItem('typeTransaction', '');
      }
    } else {
      setTimeout(() => {
        this.lazyLoaderService.loadScript(
          'https://cdn.jsdelivr.net/npm/gijgo@1.9.6/js/gijgo.min.js'
        );
        this.transaction = new Transaction();
        this.menu = Menu.ListTransaction;
        this.applyJqueryScript();
        this.resetFilter();
      });
    }

    // $('#gtModal').on('hidden.bs.modal', function () {
    //   $(this).removeClass('d-flex align-items-center');
    // });
  }

  applyJqueryScript(): void {
    const that = this;
    $(document).ready(function () {
      $('.datepicker').remove();

      $('#startDate').datepicker({
        autoclose: true,
        uiLibrary: 'bootstrap4',
        format: 'yyyy-mm-dd',
        minDate: new Date(new Date().getTime() - 2592000000),
        maxDate: new Date(),
        change: function (e) {
          that.startDateOnChanged();
        },
      });
      $('#endDate').datepicker({
        autoclose: true,
        uiLibrary: 'bootstrap4',
        format: 'yyyy-mm-dd',
        minDate: new Date(new Date().getTime() - 2592000000),
        maxDate: new Date(),
        change: function (e) {
          that.endDateOnChanged();
        },
      });

      $('body').click(function (evt) {
        if ($(evt.target).closest('.input-group-append').length) {
          return;
        }

        // if ($('.datepicker').eq(0).css('display') !== 'none') {
        //   $('.datepicker').eq(0).css('display', 'none');
        // }

        // if ($('.datepicker').eq(1).css('display') !== 'none') {
        //   $('.datepicker').eq(1).css('display', 'none');
        // }
      });

      $('ul.tabs li').click(function () {
        const tab_id = $(this).attr('data-tab');

        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $('#' + tab_id).addClass('current');
      });
    });
  }

  loadData() {
    if (this.start !== '' && this.end !== '') {
      this.loadCreatedTrans(this.start, this.end, this.filterCreated);
      this.loadProcessedTrans(this.start, this.end);
      this.loadSentTrans(this.start, this.end);
      this.loadReceivedTrans(this.start, this.end, this.filterReceived);
      if (!this.isUserGT()) {
        this.loadPoolOrder(this.start, this.end, this.filterPoolOder, this.offset, this.limit);
      } else {
        this.loadReceivedTransGt(this.start, this.end, this.filterReceivedGt, this.receivedGtMetaData.page, this.receivedGtMetaData.limit);
      }
    } else if (this.start === '' && this.end === '') {
      // this.loadPoolOrder('', '', this.filterPoolOder, this.offset, this.limit);
      if (!this.isUserGT()) {
        this.loadPoolOrder('', '', this.filterPoolOder, this.offset, this.limit);
      }
      const start = this.datepipe.transform(
        new Date().getTime() - 604800000,
        'yyyy-MM-dd'
      );
      const end = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.loadCreatedTrans(start, end, this.filterCreated);
      this.loadProcessedTrans(start, end);
      this.loadSentTrans(start, end);
      this.loadReceivedTrans(start, end, this.filterReceived);
      if (this.isUserGT()) {
        this.loadReceivedTransGt(start, end, this.filterReceivedGt, this.receivedGtMetaData.page, this.receivedGtMetaData.limit);
      }
    }
  }

  startDateOnChanged() {
    firebase.analytics().logEvent('transaksi_filter_date_button');

    if (this.start !== $('#startDate').val()) {
      this.transCreateds = [];
      this.transProcesseds = [];
      this.transSents = [];
      this.transReceiveds = [];
      this.transPoolOrder = [];
      this.transReceivedsGt = [];
      this.limit = 10;
      this.offset = 0;
      this.receivedGtMetaData.page = 1;
      this.start = $('#startDate').val();
      if (this.end !== '') {
        if (new Date(this.end) < new Date(this.start)) {
          this.end = '';
          $('#endDate').val('');
        }
      }
      this.loadData();
    }
  }

  endDateOnChanged() {
    firebase.analytics().logEvent('transaksi_filter_date_button');

    if (this.end !== $('#endDate').val()) {
      this.transCreateds = [];
      this.transProcesseds = [];
      this.transSents = [];
      this.transReceiveds = [];
      this.transPoolOrder = [];
      this.transReceivedsGt = [];
      this.limit = 10;
      this.offset = 0;
      this.receivedGtMetaData.page = 1;
      this.end = $('#endDate').val();
      if (this.start !== '') {
        if (new Date(this.end) < new Date(this.start)) {
          this.start = '';
          $('#startDate').val('');
        }
      }
      this.loadData();
    }
  }

  resetFilter() {
    firebase.analytics().logEvent('transaksi_reset_calendar_button');

    this.offset = 0;
    this.limit = 10;
    this.receivedGtMetaData.page = 1;
    this.start = '';
    this.end = '';
    $('#startDate').val('');
    $('#endDate').val('');
    this.loadData();
  }

  navigateDetail(data: Transaction) {
    this.transaction = data;
    this.menu = Menu.DetailTransaction;
  }

  back() {
    this.ngAfterViewInit();
  }

  loadCreatedTrans(start: string, end: string, filter: number) {
    this.isLoadingCreated = true;
    this.isErrorCreated = false;
    this.transService.getCreatedTrans(
      start,
      end,
      filter,
      (resp) => {
        this.isLoadingCreated = false;
        this.alertCreated = resp.alert;
        if (resp.alert.code === 200) {
          this.transCreateds = resp.data;
        } else {
          this.isErrorCreated = true;
        }
      },
      (err) => {
        this.isLoadingCreated = false;
        this.isErrorCreated = true;
        this.alertCreated.code = 500;
        this.alertCreated.message = err;
      }
    );
  }

  loadProcessedTrans(start: string, end: string) {
    this.isLoadingProcessed = true;
    this.isErrorProcessed = false;
    this.transService.getProcessedTrans(
      start,
      end,
      (resp) => {
        this.isLoadingProcessed = false;
        this.alertProcessed = resp.alert;
        if (resp.alert.code == 200) {
          this.transProcesseds = resp.data;
        } else {
          this.isErrorProcessed = true;
        }
      },
      (err) => {
        this.isLoadingProcessed = false;
        this.isErrorProcessed = true;
        this.alertProcessed.code = 500;
        this.alertProcessed.message = err;
      }
    );
  }

  loadSentTrans(start: string, end: string) {
    this.isLoadingSent = true;
    this.isErrorSent = false;
    this.transService.getSentTrans(
      start,
      end,
      (resp) => {
        this.isLoadingSent = false;
        this.alertSent = resp.alert;
        if (resp.alert.code == 200) {
          this.transSents = resp.data;
        } else {
          this.isErrorSent = true;
        }
      },
      (err) => {
        console.log('err', err)
        this.isLoadingSent = false;
        this.isErrorSent = true;
        this.alertSent.code = 500;
        this.alertSent.message = err;
      }
    );
  }

  loadReceivedTrans(start: string, end: string, filter: number) {
    this.isLoadingReceived = true;
    this.isErrorReceived = false;
    this.transService.getReceivedTrans(
      start,
      end,
      filter,
      (resp) => {
        this.isLoadingReceived = false;
        this.alertReceived = resp.alert;
        if (resp.alert.code === 200) {
          this.transReceiveds = resp.data;
        } else {
          this.isErrorReceived = true;
        }
      },
      (err) => {
        console.log('err', err)
        this.isLoadingReceived = false;
        this.isErrorReceived = true;
        this.alertReceived.code = 500;
        this.alertReceived.message = err;
      }
    );
  }

  loadPoolOrder(start: string, end: string, status: number, offset: number, limit: number) {
    this.isLoadingPoolOrder = true;
    this.isErrorReceived = false;
    this.transService.getPoolOrder(
      start,
      end,
      status,
      offset,
      limit,
      (resp) => {
        this.isLoadingPoolOrder = false;
        this.alertReceived = resp.alert;
        if (resp.alert.code === 200) {
          this.transPoolOrder = resp.data;
          this.changeDetection.detectChanges();

          if (resp.data.length >= 10) {
            this.offset += this.limit;
            this.canShowMore = true;
          } else {
            this.canShowMore = false;
          }
        } else {
          this.isErrorPoolOrder = true;
        }
      },
      (err) => {
        this.isLoadingPoolOrder = false;
        this.isErrorPoolOrder = true;
        this.alertPoolOrder.code = 500;
        this.alertPoolOrder.message = err;
      }
    );
  }

  onChangeStatusPoolOrder(status) {
    this.filterPoolOder = status;
    this.limit = 10;
    this.offset = 0;
    if (!this.isUserGT()) {
      this.loadPoolOrder(this.start, this.end, this.filterPoolOder, this.offset, this.limit);
    } else {
      this.loadReceivedTransGt(this.start, this.end, this.filterReceivedGt, this.receivedGtMetaData.page, this.receivedGtMetaData.limit);
    }
    // this.loadPoolOrder(this.start, this.end, this.filterPoolOder, this.offset, this.limit);
  }

  showMore() {
    this.isErrorReceived = false;
    this.canShowMore = false;

    this.transService.getPoolOrder(
      this.start,
      this.end,
      this.filterPoolOder,
      this.offset,
      this.limit,
      (resp) => {
        this.alertReceived = resp.alert;
        if (resp.alert.code === 200) {
          if (resp.data.length > 0) {
            resp.data.forEach((element) => {
              this.transPoolOrder.push(element);
            });
          }

          this.offset += this.limit;
          if (resp.data.length >= this.limit) {
            this.canShowMore = true;
          }
        } else {
          this.isErrorPoolOrder = true;
        }
      },
      (err) => {
        console.log('err', err);
        this.isErrorPoolOrder = true;
        this.alertPoolOrder.code = 500;
        this.alertPoolOrder.message = err;
      }
    );
  }

  public tabCreated(): void {
    if (this.start !== '' && this.end !== '') {
      this.loadCreatedTrans(this.start, this.end, this.filterCreated);
    } else if (this.start === '' && this.end === '') {
      const start = this.datepipe.transform(
        new Date().getTime() - 604800000,
        'yyyy-MM-dd'
      );
      const end = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.loadCreatedTrans(start, end, this.filterCreated);
    }
  }

  public tabProcessed(): void {
    if (this.start !== '' && this.end !== '') {
      this.loadProcessedTrans(this.start, this.end);
    } else if (this.start === '' && this.end === '') {
      const start = this.datepipe.transform(
        new Date().getTime() - 604800000,
        'yyyy-MM-dd'
      );
      const end = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.loadProcessedTrans(start, end);
    }
  }

  public tabSent(): void {
    if (this.start !== '' && this.end !== '') {
      this.loadSentTrans(this.start, this.end);
    } else if (this.start === '' && this.end === '') {
      const start = this.datepipe.transform(
        new Date().getTime() - 604800000,
        'yyyy-MM-dd'
      );
      const end = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.loadSentTrans(start, end);
    }
  }

  public tabReceived(): void {
    if (this.start !== '' && this.end !== '') {
      this.loadReceivedTrans(this.start, this.end, this.filterReceived);
    } else if (this.start === '' && this.end === '') {
      const start = this.datepipe.transform(
        new Date().getTime() - 604800000,
        'yyyy-MM-dd'
      );
      const end = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.loadReceivedTrans(start, end, this.filterReceived);
    }
  }

  public tabPoolOrder(): void {
    this.offset = 0;
    this.limit = 10;

    //this.checkGT();

    if (this.start !== '' && this.end !== '') {
      if (!this.isUserGT()) {
        this.loadPoolOrder(this.start, this.end, this.filterPoolOder, this.offset, this.limit);
      } else {
        this.loadReceivedTransGt(this.start, this.end, this.filterReceivedGt, this.receivedGtMetaData.page, this.receivedGtMetaData.limit);
      }
      // this.loadPoolOrder(this.start, this.end, this.filterPoolOder, this.offset, this.limit);
    } else if (this.start === '' && this.end === '') {
      const start = this.datepipe.transform(
        new Date().getTime() - 604800000,
        'yyyy-MM-dd'
      );
      const end = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      if (!this.isUserGT()) {
        this.loadPoolOrder(start, end, this.filterPoolOder, this.offset, this.limit);
      } else {
        this.loadReceivedTransGt(start, end, this.filterReceivedGt, this.receivedGtMetaData.page, this.receivedGtMetaData.limit);
      }
      // this.loadPoolOrder(start, end, this.filterPoolOder, this.offset, this.limit);
    }
  }

  getIconPoType(po_type: PoType): string {
    if (po_type == PoType.CustomerPortal) {
      return 'assets/img/customer-portal.png';
    } else if (po_type == PoType.EzView) {
      return 'assets/img/ic_ezview.png';
    } else {
      return 'assets/img/call-center.png';
    }
  }

  goToAddProduct() {
    this.router.navigate(['/product/add']);
  }

  navigateDetailPoolOrder(id: string) {
    this.poolOrderId = id;
    this.menu = Menu.DetailPoolOrder;
  }

  navigateDetailGT(event: any, data: TransactionGt) {
    if(!$(event.target).hasClass("cancel-transaction-gt") && !$(event.target).hasClass("confirm-transaction-gt")) {
      window.scrollTo(0, 0);
      this.transactionGt = data;
      this.menu = Menu.DetailTransactionGt;
    }
  }

  // checkGT() {
  //   const isGT = localStorage.getItem('gtStatus');
  //   const top = localStorage.getItem('topStatus');

  //   if (isGT === 'true' && top === 'true') {
  //     // $(".gtModal").addClass('d-flex align-items-center');
  //     // $(".gtModal").modal("toggle");
  //   }
  // }

  isUserGT() {
    const isGT = localStorage.getItem('gtStatus');
    const top = localStorage.getItem('topStatus');

    if (isGT === 'true' && top === 'true') {
      return true;
    } else {
      return false;
    }
  }

  public tabReceivedGt(): void {
    this.receivedGtMetaData.page = 1
    if (this.start !== '' && this.end !== '') {
      this.loadReceivedTransGt(this.start, this.end, this.filterReceivedGt, this.receivedGtMetaData.page, this.receivedGtMetaData.limit);
    } else if (this.start === '' && this.end === '') {
      const start = this.datepipe.transform(
        new Date().getTime() - 604800000,
        'yyyy-MM-dd'
      );
      const end = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.loadReceivedTransGt(start, end, this.filterReceivedGt, this.receivedGtMetaData.page, this.receivedGtMetaData.limit);
    }
  }

  loadReceivedTransGt(start: string, end: string, filter: number, page: number, limit: number, isShowMore: boolean = false) {
    this.isLoadingReceivedGt = true;
    this.isErrorReceivedGt = false;
    this.transService.getReceivedTransGt(
      start,
      end,
      filter,
      page,
      limit,
      (resp) => {
        this.isLoadingReceivedGt = false;
        this.alertReceivedGt = resp.alert;
        if (resp.alert.code === 200) {
          this.receivedGtMetaData = _.omit(resp.data, 'items');
          if (isShowMore) {
            this.transReceivedsGt = this.transReceivedsGt.concat(resp.data.items);
          } else {
            this.transReceivedsGt = resp.data.items;
          }
        } else {
          this.isErrorReceivedGt = true;
        }
      },
      (err) => {
        this.isLoadingReceivedGt = false;
        this.isErrorReceivedGt = true;
        this.alertReceivedGt.code = 500;
        this.alertReceivedGt.message = err;
      }
    );
  }

  showMoreReceivedGt() {
    this.receivedGtMetaData.page = this.receivedGtMetaData.page + 1;
    this.receivedGtMetaData.isShowMore = true;
    if (this.start !== '' && this.end !== '') {
      this.loadReceivedTransGt(this.start, this.end, this.filterReceivedGt, this.receivedGtMetaData.page, this.receivedGtMetaData.limit, true);
    } else if (this.start === '' && this.end === '') {
      const start = this.datepipe.transform(
        new Date().getTime() - 604800000,
        'yyyy-MM-dd'
      );
      const end = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.loadReceivedTransGt(start, end, this.filterReceivedGt, this.receivedGtMetaData.page, this.receivedGtMetaData.limit, true);
    }
  }

  cancelTransactionConfirmationGt(transaction: TransactionGt) {
    this.transactionGt = transaction;
    $("#cancelTransactionConfirmation").modal("show");
  }

  hideCancelTransactionConfirmationGt() {
    $("#cancelTransactionConfirmation").modal("hide");
    // this.transactionGt = null;
  }

  cancelTransactionGT() {
    $("#cancelTransactionConfirmation").modal("hide");
    $("#loader").modal("show");
    this.transService.cancelTransactionGt(
      this.transactionGt.id,
      (resp) => {
        this.transactionGt = null;
        $('#loader').modal("hide");
        if (resp.alert.code === 200) {
          window.scrollTo(0, 0);
          this.menu = 0;
          this.receivedGtMetaData.page = 1;
          this.loadReceivedTransGt(this.start, this.end, this.filterReceivedGt, this.receivedGtMetaData.page, this.receivedGtMetaData.limit);
        } else {
          this.alertComponent.show(resp.alert.code, resp.alert.message);
        }
      },
      (err) => {
        $("#loader").modal("hide");
        this.transactionGt = null;
        this.alertComponent.show(err.error.alert.code, err.error.alert.message);
      }
    );
  }

  onChangeStatusReceivedGt(filterReceivedGt) {
    this.receivedGtMetaData.page = 1;
    this.loadReceivedTransGt(this.start, this.end, filterReceivedGt, this.receivedGtMetaData.page, this.receivedGtMetaData.limit);
  }

  openCallCenterModal() {
    $("#call-center-dialog").modal("show");
  }
}
